import {Record, type RecordOf} from 'immutable';
import type {BindingTransformer} from '@packages/systems/dynamo/binding-types';
// Contains the data required for rendering an item's field value into the element tree

type BindingShape = {
  id: string;
  to: string[];
  from: string[];
  type: string;
  filter: BindingTransformer;
};

const Binding = Record<BindingShape>(
  {
    id: '',
    to: [],
    from: [],
    type: '',
    filter: {type: 'identity', params: []},
  },
  'Binding'
);

export type BindingType = RecordOf<BindingShape>;

export const BINDING_CONTEXT_KEYS = {
  dyn: 'dyn',
  search: 'search',
} as const;

export default Binding;
